export interface KnowledgeItem {
  id: string;
  title: string;
  description: string;
  image: string;
  category: string;
}

export const knowledgeItems: KnowledgeItem[] = [
  {
    id: "1",
    title: "Nhà rông Bahnar",
    description: "Tìm hiểu về phong tục tập quán, lễ hội truyền thống đặc sắc của người Bahnar",
    image: "https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/d6d6c04fcd9086d70fa94b137e3eb74b.jpeg",
    category: "Văn hóa"
  },
  {
    id: "2",
    title: "Trang phục truyền thống của người Bahnar",
    description: "Học những từ vựng cơ bản, câu chào hỏi thông dụng trong tiếng Bahnar",
    image: "https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/9fd8e1addd8893a50fc35eff7d04e071.jpeg",
    category: "Ngôn ngữ"
  },
  {
    id: "3",
    title: "Ẩm thực của người Bahnar",
    description: "Khám phá nét đẹp độc đáo của trang phục truyền thống Bahnar qua các thế hệ",
    image: "https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/e8440be30122662197116f3d41aefdc3.webp",
    category: "Văn hóa"
  }
];